// Logs plugin.
import * as actionTypes from './actionTypes'

/**
 * Action for setting a Logger's level.
 * @method setLevel
 * @param  {string} level  The level to be set.
 * @param  {string} [type] The type of Logger to set it for.
 */
export function setLevel (level, type) {
  return {
    type: actionTypes.SET_LEVEL,
    payload: { level, type }
  }
}

/**
 * Action for setting all of the Loggers' log level.
 * @method levelsChanged
 * @param  {Object} levelMap Mapping of logger type to level.
 * @return {Object}
 */
export function levelsChanged (levelMap) {
  return {
    type: actionTypes.LEVELS_CHANGE,
    payload: levelMap
  }
}

/**
 * Action for setting a Logger's handler.
 * @method setHandler
 * @param  {Function} handler A LogHandler function.
 * @param  {string}   [type]  The type of Logger to set it for.
 */
export function setHandler (handler, type) {
  return {
    type: actionTypes.SET_HANDLER,
    payload: { handler, type }
  }
}

/**
 * Action for setting all of the Loggers' log handler.
 * @method handlersChanged
 * @param  {Object} handlerMap Mapping of logger type to handler.
 * @return {Object}
 */
export function handlersChanged (handlerMap) {
  return {
    type: actionTypes.HANDLERS_CHANGE,
    payload: handlerMap
  }
}
